import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { nameOf } from '../../../../../core/functions/string-helpers';
import { CreditCardSummary } from '../../../../../core/models/commerce/cards-on-file/credit-card-summary';
import { CardOnFileValidationMessages } from '../constants/card-on-file-validation-messages';

export function notExpiredValidator(
    getCards: () => CreditCardSummary[],
    isExpired: (card: CreditCardSummary) => boolean,
): ValidatorFn {
    return (cardOnFileIdControl: AbstractControl): ValidationErrors | null => {
        const cardOnFileId: number | null = cardOnFileIdControl.value;

        if (cardOnFileId === null) {
            return null;
        }

        const card = getCards().find((c) => c.id === cardOnFileId);
        if (!card) {
            return null;
        }

        const selectedCreditCardIsExpired = isExpired(card);

        if (selectedCreditCardIsExpired) {
            return {
                [nameOf<typeof CardOnFileValidationMessages>(
                    'creditCardExpired',
                )]: CardOnFileValidationMessages.creditCardExpired,
            };
        }

        return null;
    };
}

/**
 * Validator function to check if a control's value exceeds a specified maximum amount.
 *
 * @param max The maximum allowed value for the control.
 * @param error An object containing the label and message to be used in the validation error.
 * @returns A ValidatorFn that validates the control's value against the specified maximum amount.
 */
export function maxAmountValidator(
    max: number,
    error: { label: string; message: string },
): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value === null || control.value === '') {
            return null;
        }

        if (control.value > max) {
            return {
                [error.label]: error.message,
            };
        }

        return null;
    };
}
